<template>
  <div>
    <v-card class="card--flex-toolbar" flat>
        <v-tabs color="grey lighten-3" v-model="current_tab" dark slider-color="grey darken-4">
            <v-tab ripple v-for="tab in tabs" :key="tab.href" :to="{name: tab.route_name}" class="grey--text text--darken-4 caption">{{tab.text}}</v-tab>
        </v-tabs>
    </v-card>
    <v-card v-if="isLoading" height="50vh">
      <v-content class="content-background">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    </v-card >
     <router-view v-else
      :company.sync="company"
      :members="members"
      :mailchimpLists="mailchimpLists"
      @getMailchimpLists="getMailchimpLists"
      @onSave="updateCompany()"
      @onGenerateNewOAuthSecret="generateNewOAuthSecret"
      @getMembers="getMembers()"
      @handleCompanySync="bootstrap()"
    ></router-view>

  </div>
</template>
<script>
import i18n from "@/i18n";
import DEFINES from '@/defines';
import company from '../../../store/modules/company';
import { mapState, mapGetters } from "vuex";
export default {
  name: "CompanyRoot",
  components: {

  },
  data() {
    return {
      active: null,
      current_tab: 'overview',
      company: null,
      members: null,
      mailchimpLists: [],
      isLoading: false,
      tabs: [
          {
            text: i18n.t('company.page.tab.profile'),
            route_name: 'CompanyProfile'
          },
          {
            text: i18n.t('company.page.tab.payment'),
            route_name: 'CompanyPayment'
          },
          {
            text: i18n.t('company.page.tab.theme'),
            route_name: 'CompanyTheme'
          },
          {
            text: i18n.t('company.page.tab.team'),
            route_name: 'CompanyTeam'
          },
          {
            text: i18n.t('company.page.tab.settings'),
            route_name: 'CompanySetting'
          },
          {
            text: i18n.t('company.page.tab.whitelabel'),
            route_name: 'CompanyWhiteLabel'
          },
          {
            text: i18n.t('company.page.tab.history'),
            route_name: 'CompanyHistory'
          },
          {
            text: i18n.t('company.page.tab.invoice'),
            route_name: 'CompanyInvoice'
          },
          {
            text: 'Festival Homepage',
            route_name: 'CompanyFestivalHomepagge'
          },
          {
            text: i18n.t('company.page.tab.cookies'),
            route_name: 'CompanyCookies'
          },
      ]
    };
  },
  created() {
    this.bootstrap();
  },
  computed: {
    ...mapGetters("company", {
        selected_company_id: "getSelected",
    }),
  },
  methods: {
    /**
     * Fetch all dependency of a film in paraent
     */
    async bootstrap() {
      this.isLoading = true;
      await Promise.all([
        this.$store.dispatch("company/get", {
            id: this.$route.params.company_id
        }),
        this.$store.dispatch("company/getMembers", {
          id: this.$route.params.company_id,
        })
      ])
      .then((responses) => {
        this.company = responses[0];
        this.validateCompanyCustomProperties();
        this.validateCompanyMetaInfo();
        this.members = responses[1].members
        this.getMailchimpLists(this.company)
      }).catch((error) => {
         this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    validateCompanyCustomProperties(){
        if (!this.company.custom_properties.hasOwnProperty("message")) {
          this.company.custom_properties.message = "";
        }
        if (!this.company.custom_properties.hasOwnProperty("darkMode")) {
          this.company.custom_properties.darkMode = false;
        }
        if (this.company.custom_properties.hasOwnProperty("fontFamily")) {
          // set custom fonts in defines
          if(this.company.custom_properties.fontFamily.text == DEFINES.FONT_FAMILIES[DEFINES.FONT_FAMILIES.length-1].text){
            DEFINES.FONT_FAMILIES[DEFINES.FONT_FAMILIES.length-1] = this.company.custom_properties.fontFamily;
          }
        }
        if (!this.company.custom_properties.hasOwnProperty("fontFamily")) {
          this.company.custom_properties.fontFamily = DEFINES.DEFAULT_FONTS;
        }
        if (
          !this.company.custom_properties.hasOwnProperty("booking_revenue_calculation_time")
        ) {
          this.company.custom_properties.booking_revenue_calculation_time =
            DEFINES.MONETIZATION.CALCULATE_REVENUE_AFTER_HOURS;
        }
        if (!this.company.custom_properties.hasOwnProperty("use_logo_as_header_bg")) {
          this.company.custom_properties.use_logo_as_header_bg = false;
        }
        if(!this.company.custom_properties.hasOwnProperty('powered_by_message')){
          this.company.custom_properties.powered_by_message = null;
        }
    },
    validateCompanyMetaInfo(){
      if (!this.company.meta_info) {
        this.company.meta_info = {
          keywords:[]
        };
      }
    },
    async updateCompany() {

        await this.$store.dispatch(
          "company/update",
          this.company
        )
        .then((response) => {
          this.company = response.company;
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("message.success.updated"),
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },
     async generateNewOAuthSecret() {

        await this.$store.dispatch(
          "company/generateNewOAuthSecret",this.company
        )
        .then((response) => {
          this.company = response.company;
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("message.success.updated"),
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },
    async getMailchimpLists(company) {
      // console.log('company -->',company)
      if (
        !company.custom_properties.mcApiKey ||
        company.custom_properties.mcApiKey.length < 25
      ) {
        return (company.custom_properties.mcListId = "");
      }
      try {
        let response = await this.$store.dispatch("company/getMailchimpLists", {
          apiKey: company.custom_properties.mcApiKey,
        });
        this.mailchimpLists = response;
      } catch (error) {
        this.mailchimpLists = [];
        // console.log(error.message);
      } finally {
        // set mcListId null if not exist in updated list
        if (company.custom_properties.mcListId) {
          var found = this.mailchimpLists
            ? this.mailchimpLists.some(
                (list) => list.id == company.custom_properties.mcListId
              )
            : false;
          if (!found) company.custom_properties.mcListId = "";
        }
      }
    },

    async getMembers() {
      await this.$store.dispatch("company/getMembers", {
          id: this.selected_company_id,
      })
      .then((response) => {
        this.members = response.members
      })
      .catch((error) => {
          this.$store.dispatch("app/showMessage", {
              message: error.message,
              color: "error",
          });
      })
    }
  },
};
</script>
